import React, { useState } from 'react';
import {
  Table, TableBody, TableCell, Button, TableContainer, TableHead, TableRow, Checkbox, Paper, IconButton, Chip,
  MenuItem,
  Menu,
  Typography
} from '@mui/material';
import { Delete, ArrowDropDown } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { useDispatch } from 'react-redux';
import DeleteModal from '../../component/reusable/deleteModal/DeleteModal';
import CatPagination from '../../component/reusable/catPagination/CatPagination';
import { useNavigate } from 'react-router-dom';
import Operations from '../../component/reusable/Operations';
import { fomateDate, getLeafCategoryName } from '../../utils/fomateDate';
import { deleteCategoriesThunk, setEditCategory } from '../../redux/category/getAllCategorySlice';
import { deleteProductThunk } from '../../redux/productSlice';
import { Edit, Edits, Filter } from '../../Svg';
import styles from "../../component/addCategoryForm/addCategoryForm.module.css";


// Styled components
const SearchInput = styled(Paper)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  borderRadius: '8px',
  boxShadow: 'none',
  border: `1px solid ${theme.palette.divider}`,
  width: '320px',
  fontFamily: `'Public Sans', sans-serif`,
}));

const ActionButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  marginRight: theme.spacing(1),
  fontSize: '0.875rem',
  color: '#512DA8',
  backgroundColor: '#F0F1F3',
  fontSize: '14px',
  fontWeight: '600 !important',
  fontFamily: `'Public Sans', sans-serif`,
  '&:hover': {
    backgroundColor: theme.palette.grey[200],
  },
}));

const AddCategoryButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontSize: '0.875rem',
  backgroundColor: '#512DA8',
  color: '#fff',
  fontFamily: `'Public Sans', sans-serif`,
  '&:hover': {
    backgroundColor: '#512DA8',
    opacity: '0.65',
  },
}));
// Styled components using MUI's `styled` API
const TableContainerStyled = styled(TableContainer)(({ theme }) => ({
  borderRadius: 8,
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  border: '1px solid #E0E2E7',
}));

const HeaderCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 'bold',
  backgroundColor: '#f8f9fa',
  color: '#495057',
  padding: '6px 0px 0px 20px',
  fontFamily: `'Public Sans', sans-serif !important`,

}));

const TableCells = styled(TableCell)(({ theme }) => ({
  paddingLeft: '20px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const ActionIcons = styled(TableCell)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  paddingLeft: '6px',
  borderBottom: '1px solid rgba(224, 224, 224, 1)',
}));

const ProductText = styled(TableCell)(({ theme }) => ({
  color: '#495057',
  fontWeight: 'bold',
  paddingLeft: '20px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const InactiveChip = styled(Chip)(({ theme }) => ({
  backgroundColor: '#ffc9c9',
  color: '#d9534f',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '14px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const ActiveChip = styled(Chip)(({ theme }) => ({
  backgroundColor: '#d4edda',
  color: '#28a745',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '14px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));




const ProdTable = ({ product, start, end, setPage, page, itemsPerPage, setStatus, totalItems, handleOpenMenu }) => {

console.log(product);


  const [selectedId, setSelectedId] = useState(null)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [isModalOpen, setIsModalOpen] = useState(false);


 
  const handleEditClick = (id) => {
    // dispatch(setEditCategory(category));
    navigate(`/products/editProduct/${id}`)
  };


  const deleteCategory = () => {
    dispatch(deleteProductThunk(selectedId))
    setIsModalOpen(false);

  }


  const handleDeleteClick = (id) => {
    setIsModalOpen(true);
    setSelectedId(id)
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (status) => {
    if (status) {
      setStatus(status)

    }
    setAnchorEl(null);
  };

  return (
    <>

      <TableContainerStyled component={Paper} style={{maxWidth:640}}>
        <div style={{ display: 'flex', justifyContent:'space-between', alignItems: 'center', padding: "10px" }}>
          <div style={{ display: 'flex' }}>
            <div style={{ marginLeft: '10px', fontSize: '18px', fontWeight:"600" }}>Product stock</div>
            <div style={{
              marginLeft: '10px', padding: "6px 4px", borderRadius: '8px', fontSize: '14px', 
              color: '#F86624',
              background: "#FFF0EA",
            }}>
              {totalItems} Out of stock
            </div>
          </div>
          <div className={styles.buttonGroup}>
            {/* <div style={{ padding: "10px 0px" }}>
              <ActionButton
                onClick={handleClick}
                sx={{
                  color: '#667085',
                  border: '1px solid #E0E2E7',
                  background: '#fff',
                  borderRadius: '8px',
                  marginRight:"0px"
                }}
              >
                <Filter /> Status
              </ActionButton>
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  'aria-labelledby': 'status-button',
                }}
              >
                <MenuItem onClick={() => handleClose('ACTIVE')}
                  sx={{
                    borderBottom: '1px solid #E6E1E5',
                    fontSize: '14px',
                    color: '#667085',
                  }}>Active</MenuItem>
                <MenuItem onClick={() => handleClose('INACTIVE')}
                  sx={{
                    fontSize: '14px',
                    color: '#667085',
                  }}>Inactive</MenuItem>
              </Menu>
            </div> */}
            <div style={{ padding: "10px 10px 10px 0px" }}>
              <button type="submit" className={styles.updateButton} onClick={()=>navigate('/products/allProduct')}> See More</button>
            </div>
          </div>
        </div>
        <Table>
          <TableHead>
            <TableRow>
              <HeaderCell>
                Product
                <IconButton onClick={(e) => handleOpenMenu('product_name')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>


              <HeaderCell>
                Stock
                <IconButton onClick={(e) => handleOpenMenu('inventory.stock')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Price
                <IconButton onClick={(e) => handleOpenMenu('pricing.sale_price')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Status
                <IconButton onClick={(e) => handleOpenMenu('status')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Action
              </HeaderCell>
            </TableRow>

          </TableHead>

          <TableBody >
            {product?.map((row) => (
              <TableRow key={row.id}>

                <TableCells sx={{
                  width: '20%',

                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div>
                      {
                        row?.assets?.featuredImage ? <img src={row?.assets?.featuredImage} style={{ width: 44, height: 44, borderRadius: 2 }} /> : <img src="/assets/profile.png" />
                      }
                    </div>
                  <div style={{ maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      <strong style={{ color: '#1D1F2C' }}> {row?.productOverview?.productNumber}</strong>
                      <div style={{ fontSize: '14px', color: '#667085', fontWeight: '500', }}>
                        {getLeafCategoryName(row?.categories)}
                      </div>
                    </div>
                  </div>
                </TableCells>

                {/* <ProductText sx={{ width: '13%' }}>{row.inventory?.sku}</ProductText> */}
              
                <ProductText sx={{ width: '13%' }}>{row?.inventory?.qtyAvailable}</ProductText>
                <ProductText sx={{ width: '13%' }}>
                  {row.quantityTable[0]?.breakQty} : ₹{row.quantityTable[0]?.unitPrice}
                  </ProductText>

                <TableCells sx={{ width: '13%' }}>
                
                    <InactiveChip label="OUT OF STOCK" size="small" />
                </TableCells>


                <Operations
                  TableCells={TableCells}
                  viewClick={() => navigate(`/products/viewProduct/${row?._id}`)}
                  editClick={() => handleEditClick(row?._id)}
                  deleteClick={() => handleDeleteClick(row?._id)}
                  hidedelete={'hide'}
                />

                <DeleteModal
                  isOpen={isModalOpen}
                  heading={'category'}
                  onClose={() => setIsModalOpen(false)}
                  onDelete={deleteCategory}
                />
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <div>
          <CatPagination
            start={start}
            end={end}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            setPage={setPage}
            page={page}
          />
        </div>
      </TableContainerStyled>

    </>
  );
};

export default ProdTable;
